let claimEmailHistoryCols = [
    {
        key: 'dateCreatedAsLocalTime',
        display: 'Date'
    },
    {
        key: 'emailTypeLabel',
        display: 'Email Type'
    },
    {
        key: 'messageTo',
        display: 'Recipient address'
    },
    {
        key: 'messageFrom',
        display: 'Sender address'
    },
    {
        key: 'messageSubject',
        display: 'Subject'
    },
    {
        key: 'createdBy',
        display: 'Created By'
    }]

export { claimEmailHistoryCols }